var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "ModalFullScreen",
    {
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c("div", { staticClass: "upgrade-modal-area" }, [
        _c("div", { staticClass: "info-icon" }, [_c("InfoIcon")], 1),
        _c("h3", [_vm._v("You are not Subscribed")]),
        _c("p", [
          _vm._v(
            " To invite Managers to your team, please select a subscription plan. In the meantime, you can build your private talent pool and add resources at no cost with your 7-day free trial. "
          ),
        ]),
        _c("p", [_vm._v("You are currently on the 7 day free trial.")]),
        _c(
          "div",
          { staticClass: "btns-wrap flex gap-2 justify-end" },
          [
            _c("UiButton", {
              attrs: { id: "Cancel", buttonText: "Cancel", variant: "outline" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            }),
            _c("UiButton", {
              attrs: {
                buttonText: "View Subscriptions",
                id: "View Subscriptions",
                buttonClass: "bg-black",
              },
              on: {
                click: function ($event) {
                  return _vm.$router.push(`/profile/pricing`)
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }